import { useSession } from '../store/sessionStore';
import { useNavigation } from './navigationStore';

/** The visitor's place and the card under the answer as they are NOW; the returned function puts them back.
 *  A button commits a place BEFORE it sends the request (the run reads the place from the store); when the send is
 *  refused (`false`: a turn is running, offline) nothing may have changed — the «Где вы?» card stays, the old place
 *  stays (INV-PH-137, INV-PH-140). The revision counter is left as it is: it only ever grows. */
export function snapshotPlace(): () => void {
  const session = useSession.getState();
  const before = { agentGeo: session.agentGeo, agentGeoSet: session.agentGeoSet, agentGeoMeta: session.agentGeoMeta };
  const { preview, turn, thread, anchorId, restored } = useNavigation.getState();
  return () => {
    useSession.setState(before);
    useNavigation.setState({ preview, turn, thread, anchorId, restored });
  };
}
